var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-button',{staticClass:"gl-xs-w-full ml-sm-2",attrs:{"loading":_vm.isResolving},on:{"click":function($event){return _vm.$emit('onClick')}}},[_vm._v("\n  "+_vm._s(_vm.buttonTitle)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }